import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { getBenefitSummaryUploadUrl } from 'api/operations/productServiceV2';
import { uploadFiles } from 'global/utils/uploadFiles';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import FileUploadDelegate from 'store/general/fileUploadDelegate';
import ModalDelegate from 'store/general/modalDelegate';

interface DomainParams {
  templateId: string;
  onUpload: () => Promise<void>;
}

export default class UploadDocumentModalDelegate extends ModalDelegate {
  private _isLoading: boolean = false;
  public fileUploadDelegate: FileUploadDelegate = new FileUploadDelegate();
  private _domainParams: DomainParams;

  private _setIsLoading(status: boolean): void {
    this._isLoading = status;
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public uploadDocument = async (): Promise<void> => {
    this._setIsLoading(true);
    const uploadedFileName = this.fileUploadDelegate.uploadedFileNames[0];
    try {
      // Send file name and get url
      const res = await getBenefitSummaryUploadUrl(this._domainParams.templateId, uploadedFileName);
      await runInAction(async () => {
        await uploadFiles(this.fileUploadDelegate.uploadedFiles, { [uploadedFileName]: res }, async () => {
          toastManager.addToast('The document was successfully uploaded', ToastColorTypes.SUCCESS);
          await this._domainParams.onUpload();
        });
      });

      this._setIsLoading(false);
    } catch (error) {
      toastManager.addToast(error as string, ToastColorTypes.WARNING);
    }
  };

  constructor(domainParams: DomainParams) {
    super();
    this._domainParams = domainParams;

    makeObservable<UploadDocumentModalDelegate, '_isLoading' | '_setIsLoading'>(this, {
      _isLoading: observable,

      isLoading: computed,
      _setIsLoading: action.bound,
      uploadDocument: action.bound,
    });

    reaction(
      () => this.isVisible,
      (isVisible) => {
        runInAction(() => {
          this.fileUploadDelegate.setIsFileUploadReset(!isVisible);
        });
      },
    );
  }
}
